import { Page } from "../../../../../helbest";
import { Button } from "antd";
import HeaderBack from "../../../../../helbest/HeaderBack/HeaderBack";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useLangNavigate } from "../../../../../hooks/useLangNavigate";
import Steps from "../../Steps/Steps";
import styles from "./SuccessQRCodePage.module.css";
import DoneImg from "../../../../../assets/images/base/done.png";
import CancelImg from "../../../../../assets/images/base/cancel.png";
import { useDispatch } from "react-redux";
import { reset_service_state } from "../../../../../store/actions/services_actions";

const SuccessQRCodePage = () => {
  const navigate = useLangNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const location = useLocation();
  const { status = "done" } = location.state || {};

  const isSuccess = status !== "cancel";

  const goBackToNewService = () => {
  dispatch(reset_service_state());
  navigate("/new-service/");
};


  return (
    <Page
      showFooter
      body
      customHeader={
        <HeaderBack title={t("drawer.new_service")} url="/new-service/" />
      }
      extra_header={<Steps step={4} open={true} locked />}
      customPageClassName={styles.successPage}
      headerFix
      logo
      noFooter
      back
    >
      <div>
        <div className="w-full flex flex-column justify-center items-center">
          <img
            width={200}
            src={isSuccess ? DoneImg : CancelImg}
            alt="verificitation-status"
          />
          <span
            className={styles.message}
            style={{ color: isSuccess ? "#06DF70" : "#FF0000" }}
          >
            {isSuccess ? t("services.completed") : t("services.failed")}
          </span>
        </div>

        <div className="page-fixed-footer-container">
          <Button
            onClick={goBackToNewService}
            type="primary"
            size="large"
            style={{
              width: "100%",
              maxWidth: "300px",
            }}
          >
            {t("new_service.back_to_service_page")}
          </Button>
        </div>
      </div>

    </Page>
  );
};

export default SuccessQRCodePage;